import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { Box } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
import { Spinner } from '@famly/mf_feedback_spinner';
/**
 * Loading placeholder for the KinderConnect capture detail drawer's body. Used both as the
 * `useDrawer` lazy-import fallback (the chunk itself loading) and while the capture data is being
 * fetched, so the panel shows one consistent loading state throughout rather than a blank flash
 * before the data-loading spinner mounts. Carries the same explicit width as the real content --
 * `Drawer` only applies `maxWidth` to its own title bar, not to `children`, so an unconstrained
 * fallback would let the drawer's width jump once the real content (which does constrain it) mounts.
 */
export const KinderConnectCaptureDetailDrawerSkeleton = () => (_jsx(Box, { width: { base: '100vw', mobileLandscape: '472px' }, boxSizing: "border-box", padding: { base: 3, tabletPortrait: 6 }, children: _jsx(Stack, { justifyContent: "center", marginY: 6, children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) }) }));
